const insuranceCoverageTypeValues = {
  Medicare: 'Medicare' as const,
  Medicaid: 'Medicaid' as const,
  Other: 'Other' as const,
  None: 'None' as 'Other',
};

type insuranceCoverageTypeValues =
  (typeof insuranceCoverageTypeValues)[keyof typeof insuranceCoverageTypeValues];

export { insuranceCoverageTypeValues };
